(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-quantity-popup"] && !Shopify.designMode) return;
  try {
    (() => {
  const dialog = document.getElementById('ob-quantity-popup');
  const configNode = document.getElementById('ob-quantity-popup-config');
  if (!dialog || !configNode || dialog.dataset.ready) return;
  dialog.dataset.ready = 'true';
  const cfg = JSON.parse(configNode.textContent);
  const button = dialog.querySelector('[data-quantity-add]');
  const status = dialog.querySelector('[data-quantity-status]');
  const setCartControlsBusy = value => document.querySelectorAll('cart-items-component').forEach(component => {
    component.classList.toggle('cart-items-disabled', value);
    component.setAttribute('aria-busy', String(value));
  });
  const pendingKey = 'ob-quantity-pending';
  const url = cfg.cartUrl.replace(/\/$/, '');
  const text = (value, vars = {}) => Object.entries(vars).reduce((s, [k, v]) => s.replaceAll('{' + k + '}', String(v)), value);
  const totals = items => {
    const result = {};
    for (const item of items || []) result[item.id || item.variant_id] = (result[item.id || item.variant_id] || 0) + item.quantity;
    return result;
  };
  let before = totals(cfg.initial);
  let selected = null;
  let tier = null;
  let busy = false;
  let running = false;
  let repeat = false;
  let timer = null;
  let preferredId = null;
  const eligible = item => !item.selling_plan_allocation && !item.gift_card;
  const count = cart => cart.items.filter(eligible).reduce((n, item) => n + item.quantity, 0);
  const appliedPercent = (cart, tiers) => {
    const configured = new Set((tiers || []).map(item => Number(item.percent)).filter(Number.isFinite));
    return (cart.cart_level_discount_applications || [])
      .filter(discount => discount.type === 'automatic' && discount.value_type === 'percentage')
      .map(discount => Number(discount.value))
      .filter(Number.isFinite)
      .map(value => value < 1 ? Math.round(value * 100) : Math.round(value))
      .filter(value => configured.has(value))
      .reduce((highest, value) => Math.max(highest, value), 0);
  };
  const read = async () => {
    const response = await fetch(url + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error(cfg.texts.error);
    return response.json();
  };
  const paint = (cart, item) => {
    const quantity = count(cart);
    selected = item && eligible(item) ? cart.items.find(line => line.key === item.key) || cart.items.find(eligible) : cart.items.find(eligible);
    tier = cfg.tiers.find(t => t.quantity > quantity) || null;
    const actual = appliedPercent(cart, cfg.tiers);
    const bestPercent = cfg.tiers.reduce((highest, item) => Math.max(highest, Number(item.percent) || 0), 0);
    dialog.querySelector('[data-quantity-product]').textContent = selected?.product_title || selected?.title || '';
    dialog.querySelector('[data-quantity-message]').textContent = tier
      ? text(cfg.texts.suggest, { count: tier.quantity - quantity, percent: tier.percent })
      : actual >= bestPercent && bestPercent > 0 ? text(cfg.texts.best, { percent: bestPercent }) : cfg.texts.notApplied;
    button.hidden = !tier || !selected;
    button.textContent = tier ? text(cfg.texts.button, { count: tier.quantity - quantity, percent: tier.percent }) : '';
    dialog.querySelectorAll('[data-quantity-tier]').forEach(el => {
      const tierForElement = cfg.tiers.find(item => Number(item.quantity) === Number(el.dataset.quantityTier));
      const unlocked = Boolean(tierForElement && actual >= Number(tierForElement.percent));
      el.classList.toggle('is-reached', unlocked);
    });
  };
  async function check() {
    if (busy) return;
    if (running) { repeat = true; return; }
    running = true;
    try {
      const cart = await read();
      const after = totals(cart.items);
      const increased = cart.items.filter(item => (after[item.id] || 0) > (before[item.id] || 0));
      before = after;
      try { sessionStorage.removeItem(pendingKey); } catch {}
      const item = increased.find(item => eligible(item) && String(item.id) === String(preferredId)) || increased.find(eligible);
      if (!item) {
        if (dialog.open) {
          if (!cart.items.some(eligible)) dialog.close();
          else paint(cart, selected);
        }
        return;
      }
      status.textContent = '';
      paint(cart, item);
      if (!dialog.open) dialog.showModal();
    } catch {
      // A failed add or cart read must not interrupt the store's purchase flow.
    } finally {
      running = false;
      if (repeat) { repeat = false; schedule(); }
    }
  }
  function schedule(id) {
    if (id) preferredId = id;
    clearTimeout(timer);
    timer = setTimeout(check, 180);
  }
  for (const close of dialog.querySelectorAll('[data-quantity-close]')) close.addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const r = dialog.getBoundingClientRect();
    if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
  });
  button.addEventListener('click', async () => {
    if (busy || !selected || !tier) return;
    if (document.documentElement.hasAttribute('data-ob-cart-busy') || document.querySelector('cart-items-component.cart-items-disabled')) {
      status.textContent = cfg.texts.busy;
      return;
    }
    busy = true;
    document.documentElement.setAttribute('data-ob-cart-busy', 'quantity-suggestion');
    setCartControlsBusy(true);
    button.disabled = true;
    status.textContent = cfg.texts.busy;
    const variantId = selected.id;
    const targetKey = selected.key;
    const targetQuantity = tier.quantity;
    try {
      const fresh = await read();
      const line = fresh.items.find(item => item.key === targetKey)
        || fresh.items.find(item => item.id === variantId && eligible(item));
      if (!line) throw new Error(cfg.texts.error);
      const extra = Math.max(0, targetQuantity - count(fresh));
      let cart = fresh;
      if (extra) {
        const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(el => el.dataset.sectionId))].slice(0, 5);
        const response = await fetch(url + '/change.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: line.key, quantity: line.quantity + extra, sections, sections_url: location.pathname })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || cfg.texts.error);
        cart = result;
      }
      before = totals(cart.items);
      paint(cart, cart.items.find(item => item.id === variantId && eligible(item)));
      status.textContent = cfg.texts.updated;
      if (window.OB?.Cart?.paint) window.OB.Cart.paint(cart.item_count);
      document.dispatchEvent(new CustomEvent('cart:update', { detail: { resource: cart, sourceId: 'quantity-suggestion', data: { source: 'quantity-suggestion', itemCount: cart.item_count, sections: cart.sections || {} } } }));
    } catch (error) {
      status.textContent = error.message || cfg.texts.error;
    } finally {
      busy = false;
      if (document.documentElement.getAttribute('data-ob-cart-busy') === 'quantity-suggestion') {
        document.documentElement.removeAttribute('data-ob-cart-busy');
      }
      if (!document.documentElement.hasAttribute('data-ob-cart-busy')) setCartControlsBusy(false);
      button.disabled = false;
    }
  });
  document.addEventListener('ob:cart:added', event => {
    const result = event.detail;
    schedule(result?.items?.[0]?.id || result?.id);
  });
  document.addEventListener('cart:update', event => {
    const data = event.detail?.data;
    if (data?.didError || data?.source === 'quantity-suggestion') return;
    if (data?.source === 'product-form-component') schedule(data.variantId || event.detail.sourceId);
    else if (dialog.open) schedule();
  });
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !/\/cart\/add(?:\.js)?$/.test(new URL(form.action, location.href).pathname)) return;
    try { sessionStorage.setItem(pendingKey, JSON.stringify({ at: Date.now(), before, id: new FormData(form).get('id') })); } catch {}
  }, true);
  if ('PerformanceObserver' in window) {
    const observer = new PerformanceObserver(list => {
      for (const entry of list.getEntries()) {
        try {
          const request = new URL(entry.name, location.href);
          if (request.origin === location.origin && /\/cart\/(?:add|change|update|clear)(?:\.js)?$/.test(request.pathname)) schedule();
        } catch {}
      }
    });
    observer.observe({ type: 'resource', buffered: false });
  }
  try {
    const pending = JSON.parse(sessionStorage.getItem(pendingKey) || 'null');
    if (pending && Date.now() - pending.at < 60000) { before = pending.before; schedule(pending.id); }
    else sessionStorage.removeItem(pendingKey);
  } catch {}
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["prepaid-offer"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('oblivion-prepaid-product')) return;
  const selector = 'oblivion-prepaid-product';
  let scheduled = false;
  let lastVariant = null;
  class PrepaidProduct extends HTMLElement {
    connectedCallback() {
      try {
        this.variants = JSON.parse(this.querySelector('[data-prepaid-product-variants]').textContent);
      } catch { this.variants = []; }
      schedule();
    }
    update(id) {
      const variant = this.variants.find(item => String(item.id) === String(id));
      if (variant) this.dataset.variantId = variant.id;
    }
  }
  const isVisible = (el) => {
    if (!el || !el.getClientRects().length) return false;
    for (let node = el; node && node !== document.body; node = node.parentElement) {
      const style = getComputedStyle(node);
      if (style.display === 'none' || style.visibility === 'hidden' || style.position === 'fixed') return false;
    }
    return !el.closest('dialog, quick-add-dialog, #quick-add-modal-content, #obBuybar, [data-sticky], .sticky-add-to-cart');
  };
  function place() {
    const source = document.querySelector('template[data-prepaid-product-template]');
    let cards = Array.from(document.querySelectorAll(selector));
    const primaryId = source?.dataset.productId || cards[0]?.dataset.productId;
    cards.forEach(card => { card.hidden = true; });
    const candidates = cards.filter(card => {
      if (card.dataset.productId !== primaryId) return false;
      card.hidden = false;
      const visible = isVisible(card);
      card.hidden = true;
      return visible && !card.hasAttribute('data-prepaid-auto');
    });
    let active = candidates[0];
    if (!active && source) {
      const anchor = Array.from(document.querySelectorAll('gp-product gp-product-price, product-price[data-product-id]')).find(el => {
        if (!isVisible(el)) return false;
        const gp = el.closest('gp-product');
        if (gp) {
          try {
            const ctx = JSON.parse(gp.getAttribute('gp-context') || '{}');
            const data = JSON.parse(el.getAttribute('gp-data') || '{}');
            return String(ctx.productId) === primaryId && data.priceType !== 'compare';
          } catch { return false; }
        }
        return el.dataset.productId === primaryId;
      });
      if (anchor) {
        /* GemPages places the current price, compare price and sale badge in
           separate columns of one gp-row. Inserting inside the current-price
           column squeezes this offer into a third of the mobile width and
           makes the other columns stretch to the card's height. Place the
           offer after that complete price row; native theme prices keep their
           existing placement directly after the price component. */
        const placementAnchor = anchor.closest('gp-row') || anchor;
        active = cards.find(card => card.hasAttribute('data-prepaid-auto'));
        if (!active) {
          const fragment = source.content.cloneNode(true);
          active = fragment.querySelector(selector);
          if (active) {
            active.setAttribute('data-prepaid-auto', '');
            placementAnchor.after(fragment);
          }
        } else if (placementAnchor.nextElementSibling !== active) placementAnchor.after(active);
      }
    }
    if (!active) return;
    active.hidden = false;
    const gp = active.closest('gp-product');
    let id = lastVariant || active.dataset.variantId;
    if (gp) {
      const field = gp.querySelector('form[action*="/cart/add"] [name="id"]');
      try {
        const context = JSON.parse(gp.getAttribute('gp-context') || '{}');
        id = field?.value || context.variantSelected?.id || id;
      } catch { id = field?.value || id; }
    }
    active.update(id);
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; place(); });
  }
  customElements.define('oblivion-prepaid-product', PrepaidProduct);
  for (const name of ['variant:update', 'variant:change', 'variantChange', 'product:variant-change']) {
    document.addEventListener(name, event => {
      const variant = event.detail?.resource || event.detail?.variant || event.detail?.data?.variant;
      if (!variant?.id) return;
      const cards = Array.from(document.querySelectorAll(selector));
      if (!cards.some(card => card.variants?.some(item => String(item.id) === String(variant.id)))) return;
      lastVariant = variant.id;
      schedule();
    });
  }
  document.addEventListener('change', event => {
    if (event.target?.name === 'id') lastVariant = event.target.value || null;
    if (event.target?.closest('gp-product, product-form, variant-picker, #obInfo')) schedule();
  });
  document.addEventListener('shopify:section:load', () => { lastVariant = null; schedule(); });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('pageshow', schedule);
  const observe = () => {
    const main = document.querySelector('#MainContent') || document.body;
    new MutationObserver(records => {
      if (records.some(record =>
        record.type === 'attributes'
          ? record.target.matches('gp-product, gp-product-button, input[name="id"]')
          : Array.from(record.addedNodes).some(node => node.nodeType === 1 && !node.closest(selector))
      )) schedule();
    }).observe(main, { childList: true, subtree: true, attributes: true, attributeFilter: ['gp-context', 'gp-data', 'value'] });
    schedule();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observe, { once: true });
  else observe();
})();
  } catch(e) { console.error(e); }
})();

})();
